export default {
  getList: {
    method: 'post',
    url: '/area/list'
  },
  create: {
    method: 'post',
    url: '/area'
  },
  update: {
    method: 'put',
    url: '/area'
  },
  delete: {
    method: 'delete',
    url: '/area'
  },
  getHistory: {
    method: 'post',
    url: '/area/history/list'
  },
  findAreas: {
    method: 'get',
    url: '/area/find?key=KEY'
  }
}
